import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "@phosphor-icons/react";
import api from "@/lib/api";
import WorkoutCard from "@/components/WorkoutCard";

export default function Feed() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/workouts/feed?limit=30");
      setItems(data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="space-y-6" data-testid="feed-page">
      <div className="flex items-end justify-between mb-2">
        <div>
          <div className="text-xs uppercase tracking-widest text-[#FF3B30] font-mono">// Feed</div>
          <h1 className="font-display text-4xl md:text-5xl font-black uppercase">Recent lifts</h1>
        </div>
        <Link
          to="/log"
          data-testid="feed-new-workout-cta"
          className="btn-primary inline-flex items-center gap-2"
        >
          <Plus size={16} weight="bold" /> Log
        </Link>
      </div>

      {loading ? (
        <div className="text-zinc-500 font-mono text-sm">Loading feed…</div>
      ) : items.length === 0 ? (
        <div className="border border-dashed border-[#27272A] p-12 text-center">
          <div className="font-display text-2xl font-bold uppercase text-zinc-400 mb-2">No workouts yet</div>
          <p className="text-zinc-500 text-sm mb-6">Be the first to log a session.</p>
          <Link to="/log" className="btn-primary inline-flex">Log first workout</Link>
        </div>
      ) : (
        items.map((w) => <WorkoutCard key={w.id} workout={w} onChange={load} />)
      )}
    </div>
  );
}
